export const callbackDocumentationMarkdown = `
# Make a request and wait for a callback
`;
